export default ($axios, publicApiUrl) => ({
  /**
   * [0904] 獲取簡易報告所需資料
   * @param {string} sid 發布報告代號
   * @returns {Object} 簡易報告物件
   */
  getReportOutline(sid) {
    return $axios.get(`${publicApiUrl}/SimpleReport?sid=${sid}`);
  },
});
